// WW Wishlist Header Dot Indicator (standalone, won't interfere with engine)
(function() {
  'use strict';

  var LS_KEY = 'ww_wishlist_v1';
  var icon = null;

  function updateDot() {
    try {
      if (!icon) {
        icon = document.getElementById('wwHeaderWishlistIcon');
        if (!icon) return;
      }

      var count = 0;
      try {
        var raw = localStorage.getItem(LS_KEY) || '[]';
        var list = JSON.parse(raw);
        count = Array.isArray(list) ? list.length : 0;
      } catch (e) {}

      icon.setAttribute('data-ww-count', String(count));
    } catch (e) {}
  }

  // Hydrate from server on login (before first updateDot)
  function hydrateFromServer() {
    try {
      if (window.__WW_CUSTOMER_LOGGED_IN__ && window.__WW_REMOTE_WISHLIST__) {
        var remote = window.__WW_REMOTE_WISHLIST__;
        if (Array.isArray(remote) && remote.length > 0) {
          var current = localStorage.getItem(LS_KEY) || '[]';
          var local = JSON.parse(current);
          
          // Only hydrate if local is empty (just logged in)
          if (!Array.isArray(local) || local.length === 0) {
            localStorage.setItem(LS_KEY, JSON.stringify(remote));
            console.log('[WW_HEADER] Hydrated from server:', remote.length, 'items');
          }
        }
      }
    } catch (e) {}
  }

  // Update on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      hydrateFromServer();
      updateDot();
    });
  } else {
    hydrateFromServer();
    updateDot();
  }


  // Update when storage changes (other tabs/windows)
  window.addEventListener('storage', function(e) {
    if (e.key === LS_KEY) updateDot();
  });

  // Update when wishlist changes (same tab)
  window.addEventListener('ww:wishlist:changed', updateDot);

  // Update immediately after login (detect customer ID change)
  var lastCustomerId = null;
  setInterval(function() {
    try {
      var currentId = window.WW_CUSTOMER_ID || window.__WW_CUSTOMER_ID || window.wwCustomerId || null;
      if (currentId && currentId !== lastCustomerId) {
        lastCustomerId = currentId;
        updateDot(); // trigger immediate update
      }
    } catch (e) {}
  }, 500); // check every 500ms for login

  // Poll every 2 seconds as fallback (lightweight)
  setInterval(updateDot, 2000);

})();


